/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 27/03/18
 */

import React, { Component } from 'react';

class DropdownBank extends Component {
  render() {
    const {
      meta: { touched, error },
      banks,
      input,
      onChangeValue,
      dis,
    } = this.props;
    return (
      <div
        className={
          touched
            ? error
              ? 'has-feedback has-error'
              : 'has-feedback has-success'
            : ''
        }
      >
        <select
          className={'form-control'}
          {...input}
          onChange={onChangeValue}
          disabled={dis}
        >
          <option hidden value="">
            - Select Bank -
          </option>
          {banks.map(bank => {
            return (
              <option key={bank.name} value={bank.name}>
                {bank.name}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}

export default DropdownBank;
